module.exports = __webpack_public_path__ + "img/caret-up-sr.f44a37ca.svg";